import {generatePath} from 'react-router';

export const DataCollectionsRoutePattern = {
  dataCollectionsRoot: '/collections',
  dataCollection: '/collections/collection/:collectionId',
  dataCollectionConfigurations:
    '/collections/collection/:collectionId/configurations',
  dataCollectionTiles: '/collections/collection/:collectionId/tiles',
  dataCollectionArrays: '/collections/collection/:collectionId/arrays',
  dataCollectionNew: '/collections/collection/new',
} as const;

type CollectionId = string;

export const DataCollectionRoutes = {
  dataCollectionsRoot: () => DataCollectionsRoutePattern.dataCollectionsRoot,
  dataCollection: (collectionId: CollectionId) =>
    generatePath(DataCollectionsRoutePattern.dataCollection, {collectionId}),
  dataCollectionConfigurations: (collectionId: CollectionId) =>
    generatePath(DataCollectionsRoutePattern.dataCollectionConfigurations, {
      collectionId,
    }),
  dataCollectionTiles: (collectionId: CollectionId) =>
    generatePath(DataCollectionsRoutePattern.dataCollectionTiles, {
      collectionId,
    }),
  dataCollectionArrays: (collectionId: CollectionId) =>
    generatePath(DataCollectionsRoutePattern.dataCollectionArrays, {
      collectionId,
    }),
  dataCollectionNew: () => DataCollectionsRoutePattern.dataCollectionNew,
};
